export default {
  timepunching: false,
  timepunches_for_week: {
    loading: false,
    loaded: false,
    data: [],
    calculated: "00:00:00"
  }
};
